import Accordion from './Accordion';
import AccordionItem from './AccordionItem';

export default Accordion;
export { AccordionItem };
